import { z } from "zod";
import { IsoTimestamp, OrderId, PlayerId, PoolId, VaultItemId } from "./ids.js";

export const StoreItemKind = z.enum(["avatar", "voucher", "cosmetic"]);
export type StoreItemKind = z.infer<typeof StoreItemKind>;

export const StockMode = z.enum(["unlimited", "pool_backed", "limited"]);
export type StockMode = z.infer<typeof StockMode>;

export const StoreCatalogueItem = z.object({
  id: z.string().uuid(),
  kind: StoreItemKind,
  pool_id: PoolId.nullable(), // voucher kinds sell from the SAME pools as drops
  price_coins: z.number().int().min(0),
  stock_mode: StockMode,
  limited_total: z.number().int().min(0).nullable(),
  limited_claimed: z.number().int().min(0).nullable(),
  active: z.boolean(),
});
export type StoreCatalogueItem = z.infer<typeof StoreCatalogueItem>;

// Purchase creates a vault_item(source: store_purchase) — one claim/fulfilment/history
// flow for won and bought alike (KICKOFF §4.2 rule 3).
export const StoreOrder = z.object({
  id: OrderId,
  player_id: PlayerId,
  item_id: z.string().uuid(),
  coins_paid: z.number().int().min(0),
  vault_item_id: VaultItemId,
  ts: IsoTimestamp,
});
export type StoreOrder = z.infer<typeof StoreOrder>;
